import { Session } from 'next-auth'
import { useEffect } from 'react'
import { isProductionEnvironment, isStagingEnvironment } from './appUtils'

export const useMeticulous = ({ session }: { session: Session | null }) => {
  useEffect(() => {
    // Only run in non-production environments where Meticulous is loaded
    if (isProductionEnvironment() || isStagingEnvironment() || !window.Meticulous?.context) {
      return
    }

    const meticulous = window.Meticulous.context

    try {
      // Record user information
      if (session?.user?.email) {
        meticulous.recordUserEmail(session.user.email)
      }

      if (session?.user?.type === 'fullyAuthenticated' && session.user.metadata?.id) {
        meticulous.recordUserId(session.user.metadata.id)

        // Record additional user context
        meticulous.recordCustomContext('organisationId', session.user.orgMetadata.organisationId)
        meticulous.recordCustomContext('organisationName', session.user.orgMetadata.name)
        meticulous.recordCustomContext('userRole', session.user.metadata.role)
      }

      // Record language and locale information
      meticulous.recordCustomContext('browserLanguage', navigator.language)

      // Record timezone
      try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        meticulous.recordCustomContext('timezone', timezone)
      } catch {
        // Fallback if timezone detection fails
        meticulous.recordCustomContext('timezone', 'unknown')
      }
    } catch (error) {
      console.error('[Meticulous] Failed to record user context:', error)
    }

    // Note: Feature flags are automatically recorded via LaunchDarkly and org-settings inspectors
  }, [session])
}
